import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactHighCharts from 'react-highcharts';
import moment from 'moment-timezone';
import Highcharts from 'highcharts';
import { filterByMonth } from '../actions';
import { placeholderConfig } from '../Highcharts';
import Select2 from '../../Extended/Select2';
import {translate} from 'react-i18next';

const Plot = ReactHighCharts.withHighcharts(Highcharts);
@translate(['dashboard'], { wait: true })
class CostPlot extends Component {
  constructor(props) {
    super(props);

    this.state = {
      leftDate: moment()
        .utc()
        .subtract(1, 'months')
        .startOf('month'),
      rightDate: moment()
        .utc()
        .startOf('month'),
    };
  }
  render() {
    const { noRidesEver, t } = this.props;
    let totalLeft = 0;
    let totalRight = 0;
    const journeysCostsFirst = this.props.leftCostReport.values
      ? this.props.leftCostReport.values.map((value, index) => {
          const date = this.state.leftDate.format('YYYY,MM,DD').split(',');
          if (
            this.state.leftDate.month() === moment().month() &&
            this.state.leftDate.year() === moment().year() &&
            index > moment().date() - 1
          ) {
            return null;
          }
          totalLeft += value;
          return {
            y: totalLeft,
            date,
          };
        })
      : [];
    const journeysCostsSecond = this.props.rightCostReport.values
      ? this.props.rightCostReport.values.map((value, index) => {
          const date = this.state.rightDate.format('YYYY,MM,DD').split(',');
          if (
            this.state.rightDate.month() === moment().month() &&
            this.state.rightDate.year() === moment().year() &&
            index > moment().date() - 1
          ) {
            return null;
          }
          totalRight += value;
          return {
            y: totalRight,
            date,
          };
        })
      : [];
    const leftTotalSum = Math.round(this.props.leftCostReport.sum);
    const rightTotalSum = Math.round(this.props.rightCostReport.sum);
    let config = {
      chart: { type: 'spline' },
      tooltip: {
        crosshairs: [
          {
            width: 1,
            dashStyle: 'solid',
            color: '#208ff6',
          },
          false,
        ],
        formatter() {
          // eslint-disable-line func-names
          let s = '';
          let color;
          const colorOpacity = 'rgba(178,178,178,0.2)';
          const colorNormal = 'rgba(178,178,178,1)';
          for (const point of this.points) {
            const pointMonth = Date.UTC(
              point.point.date[0],
              point.point.date[1] - 1,
              point.point.date[2],
            );
            if (point.color !== colorOpacity) {
              color = point.color;
            } else {
              color = colorNormal;
            }
            s += `<div class="tooltipWrap comparison">
                <span class="titile">${Highcharts.dateFormat(
                  '%B',
                  pointMonth,
                )}</span>
               </div>`;
          }
          return s;
        },
      },
      plotOptions: {
        spline: {
          marker: { enabled: false },
          lineWidth: 2,
        },
        series: {
          states: {
            hover: { enabled: false },
          },
        },
      },
      yAxis: {
        visible: true,
        title: false,
        tickInterval: 100,
        gridLineColor: '#f6f6f6',
      },
      xAxis: {
        labels: {
          formatter() {
            // eslint-disable-line func-names
            return this.value + 1;
          },
        },
      },
      series: [
        {
          color: 'rgba(178,178,178,0.2)',
          data: journeysCostsFirst,
        },
        {
          color: 'rgba(97,221,132,1)',
          data: journeysCostsSecond,
        },
      ],
    };
    config = noRidesEver ? placeholderConfig() : config;
    const selectData = [...Array(12).keys()].map(key => {
      const m = moment()
        .subtract(11 - key, 'months')
        .startOf('month');
      return {
        id: key,
        text: m.format('MMMM YYYY'),
      };
    });
    const leftSelectValue =
      11 -
      moment()
        .endOf('month')
        .diff(this.state.leftDate.startOf('month'), 'months');
    const rightSelectValue =
      11 -
      moment()
        .endOf('month')
        .diff(this.state.rightDate.startOf('month'), 'months');

    return (
      <div id="timeTab" className="tab active">
        <div className="graph-section__status">
          <div className="graph-section__filterInfo__col">
            <div className="selectWrap">
              <Select2
                className="select2 select2-graphFrom"
                style={{ width: '83%' }}
                data={selectData}
                onSelect={item => {
                  const date = moment()
                    .utc()
                    .startOf('month')
                    .subtract(11 - item.params.data.id, 'months');
                  this.props.filter(date, true);
                  this.setState({ leftDate: date });
                }}
                defaultValue={leftSelectValue}
                options={{
                  minimumResultsForSearch: Infinity,
                }}
              />
            </div>
          </div>
          <div className="graph-section__filterInfo__col">
            <div className="selectWrap">
              <Select2
                className="select2 select2-graphFrom"
                style={{ width: '83%' }}
                data={selectData}
                onSelect={item => {
                  const date = moment()
                    .utc()
                    .startOf('month')
                    .subtract(11 - item.params.data.id, 'months');
                  this.props.filter(date);
                  this.setState({ rightDate: date });
                }}
                value={rightSelectValue}
                options={{
                  minimumResultsForSearch: Infinity,
                }}
              />
            </div>
          </div>
        </div>
        <Plot
          config={config}
          domProps={{
            id: 'sectionGraphDrivingTime',
            className: 'graph-section__graph',
          }}
        />
      </div>
    );
  }
}

CostPlot.PropTypes = {
  leftCostReport: PropTypes.object,
  rightCostReport: PropTypes.object,
  range: PropTypes.arrayOf(PropTypes.instanceOf(moment)),
  handleEvent: PropTypes.func,
  filter: PropTypes.func,
};

export default connect(
  state => ({
    noRidesEver: !(
      !state.rides.areJourneysEverLoaded || state.rides.areJourneysEverExist
    ),
    leftCostReport: state.dashboard.reports.leftCostReport,
    rightCostReport: state.dashboard.reports.rightCostReport,
  }),
  dispatch => ({
    filter(date, isLeft = false) {
      dispatch(filterByMonth({ date, isLeft }));
    },
  }),
)(CostPlot);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Plots/CostPlot.js